<template>
  <div>
    <b-modal
      hide-footer
      no-close-on-esc
      :title-html="
        `<div class='d-flex align-items-center'><span class='lock'></span>&nbsp;<span>Authentication Required!</span></div>`
      "
      :ref="refId"
      :id="refId"
      header-class="managerAuthPop__header_class"
      modal-class="managerAuthPop__modal_class"
      title-class="managerAuthPop__title_class"
      centered
      no-fade
      no-stacking
      no-enforce-focus
      no-close-on-backdrop
      @hidden="cancelAuth()"
    >
      <div class="row mx-0">
        <div class="col-12">
          <div class="col-lg-10 mx-auto align-self-center">
            <div class>
              <div class="">
                <div class="input-material">
                  <input
                    type="text"
                    v-model="username"
                    v-on:keyup.enter="authenticateLogin"
                    name="username"
                    id="username"
                    required
                    placeholder="username"
                    @click="onClickInputHandler('username')"
                  />
                  <label>Username</label>
                </div>
                <div v-if="showKeyBoard">
                  <VkeyboardFloat
                    :ID="'username'"
                    :onClickFun="
                      () => {
                        showUsernameVKeyboard = !showUsernameVKeyboard;
                      }
                    "
                  />
                  <Vkeyboard
                    :inputName="'username'"
                    :showOrHide="showUsernameVKeyboard"
                    :initialValue="username"
                    @onChangeEvent="() => {}"
                    @onKeyEnter="authenticateLogin()"
                    @changeKeyboardInput="username = $event"
                    @onClickClose="
                      () => {
                        showUsernameVKeyboard = false;
                      }
                    "
                  />
                </div>
                <p class="error_message">
                  <!--                  <span v-if="submitted && errors.has('username')">{{-->
                  <!--                    errors.first("username")-->
                  <!--                  }}</span>-->
                </p>
              </div>
              <div class="input-material">
                <input
                  type="password"
                  v-model="password"
                  v-on:keyup.enter="authenticateLogin"
                  name="password"
                  id="password"
                  required
                  placeholder="password"
                  @click="onClickInputHandler('password')"
                />
                <label>Password</label>
              </div>
              <div v-if="showKeyBoard">
                <VkeyboardFloat
                  :ID="'password'"
                  :onClickFun="
                    () => {
                      showPassVKeyboard = !showPassVKeyboard;
                    }
                  "
                />
                <Vkeyboard
                  :inputName="'password'"
                  :initialValue="password"
                  :showOrHide="showPassVKeyboard"
                  :hideTypingInput="true"
                  @onChangeEvent="() => {}"
                  @onKeyEnter="authenticateLogin()"
                  @changeKeyboardInput="password = $event"
                  @onClickClose="
                    () => {
                      showPassVKeyboard = false;
                    }
                  "
                />
              </div>
              <p class="error_message">
                <!--                <span v-if="submitted && errors.has('password')">{{-->
                <!--                  errors.first("password")-->
                <!--                }}</span>-->
              </p>
              <div class="d-flex mt-1 justify-content-center">
                <button
                  @click.prevent.stop="$bvModal.hide(refId)"
                  class="btn btn-sm btn-outline-primary mr-5"
                >
                  Cancel
                </button>
                <button
                  @click.prevent.stop="authenticateLogin"
                  class="btn btn-sm btn-primary"
                >
                  Proceed
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import PosService from "@/services/PosService.js";
  import { BASEURL } from "@/config/index";
  import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
  import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";

  export default {
    props: {
      showKeyBoard: {
        type: Boolean,
        default: true,
      },
      refId: {
        type: String,
        default: "authManagerLoginPopup",
      },
      moduleName: {
        type: String,
        default: "default",
      },
      onCheckAuth: {
        type: Function,
        default: () => console.log("default function"),
      },
    },
    components: {
      Vkeyboard,
      VkeyboardFloat,
    },
    data() {
      return {
        loaderInstance: null,
        username: "",
        password: "",
        showVKeyboard: false,
        showPassVKeyboard: false,
        showUsernameVKeyboard: false,
        submitted: false,
      };
    },
    computed: {},
    mounted() {},
    methods: {
      onClickInputHandler(event) {
        if (this.showUsernameVKeyboard && event == "password") {
          this.showUsernameVKeyboard = false;
          this.showPassVKeyboard = true;
        } else if (this.showUsernameVKeyboard && event == "username") {
          this.showUsernameVKeyboard = false;
          this.showPassVKeyboard = false;
        } else if (this.showPassVKeyboard && event == "username") {
          this.showUsernameVKeyboard = true;
          this.showPassVKeyboard = false;
        } else if (this.showPassVKeyboard && event == "password") {
          this.showUsernameVKeyboard = false;
          this.showPassVKeyboard = false;
        }
      },
      cancelAuth() {
        this.$emit("AuthValid", false);
        this.onCheckAuth({
          name: this.moduleName,
          valid: false,
          user_id: null,
        });
      },
      authenticateLogin() {
        let self = this;
        this.submitted = true;

        if (
          !this.username ||
          !this.password ||
          String(this.username).trim() == "" ||
          String(this.password).trim() == ""
        ) {
          this.submitted = false;
          this.$toasted.show("Invalid username or password");
          return;
        }

        this.showLoading();

        PosService.CheckCinemaManagerAuth({
          username: this.username,
          password: this.password,
        })
          .then((response) => {
            const { data } = response;
            if (data.status) {
              this.$emit("ManagerDetails", data.user_id);
              this.username = "";
              this.password = "";
              this.$emit("AuthValid", true);

              this.onCheckAuth({
                name: this.moduleName,
                valid: true,
                user_id: data.user_id,
              });

              this.$refs[this.refId].hide();
              if (data.user_id) {
                let userInfo = JSON.parse(localStorage.getItem("USER_INFO"));
                let USERSHIFTDATA = JSON.parse(
                  localStorage.getItem("USER_SHIFT_DATA")
                );
                console.log(userInfo, "userInfo");
                // console.log(this.moduleName, "this.moduleName");
                if (this.moduleName == "openCashDraw") {
                  try {
                    this.sendAuditLogs({
                      action: `POS USER OPEN CASH DRAWER`,
                      page_name: "CASH DRAWER",
                      api_name: "",
                    });

                    let cinema_id = localStorage.getItem("cinema_id");
                    let userData = localStorage.getItem("USER_INFO") || "";

                    if (this.$socket) {
                      console.log(
                        "print_ticket from pos_login3123425454 open cash drawer"
                      );

                      this.$socket.emit("on_print_ticket", {
                        cinema_id,
                        baseurl: BASEURL,
                        ttype: "empire-login-ticket",
                        openDrawer: "Y",
                        loginDateTime: userData,
                      });

                      console.log("print_ticket from pos_login");
                      PosService.CashDrawerLogs({
                        cinema_id: userInfo.cinema_id,
                        pos_logged_in_username: userInfo.username,
                        pos_logged_in_userId: userInfo.user_id,
                        auth_logged_in_userId: data.user_id,
                        role_id: userInfo.role_id,
                        role_name: userInfo.role_name,
                        hardware_obj: USERSHIFTDATA.hardware_obj,
                      });
                    }
                  } catch (error) {
                    console.log(error);
                  }
                }
              }
            } else {
              this.$emit("ManagerDetails", null);
              this.$emit("AuthValid", false);
              this.onCheckAuth({
                name: this.moduleName,
                valid: false,
                user_id: null,
              });

              this.$toasted.show(
                data.message ||
                  "Sorry! Something went wrong. kindly contact your administrator"
              );
            }
          })
          .catch((err) => {
            this.$emit("AuthValid", false);
            this.onCheckAuth({
              name: this.moduleName,
              valid: false,
              user_id: null,
            });
            console.log("Error:", err);
          })
          .finally(() => {
            this.hideLoading();
          });
      },
    },
  };
</script>
<style>
  .disbled-section {
    cursor: not-allowed;
    opacity: 0.4;
  }

  .managerAuthPop__title_class {
    font-size: 12px !important;
  }

  .managerAuthPop__header_class {
    padding: 0.4rem 1rem !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Partials/AuthManagerLoginPopup.vue